<div class="ppd">
  <ngx-extended-pdf-viewer class="ppd__viewer" [src]="pdfSrc"
                           [useBrowserLocale]="true"
                           [filenameForDownload]="fileName"
                           [showSidebarButton]="true"
                           [showFindButton]="false"
                           [showPagingButtons]="true"
                           [showDrawEditor]="false"
                           [showTextEditor]="false"
                           [showZoomButtons]="true"
                           [showPresentationModeButton]="false"
                           [showOpenFileButton]="false"
                           [showPrintButton]="false"
                           [showDownloadButton]="true"
                           [showSecondaryToolbarButton]="false"
                           [showRotateButton]="false"
                           [showHandToolButton]="false"
                           [showScrollingButton]="false"
                           [showSpreadButton]="false"
                           [showPropertiesButton]="false"
                           [useBrowserLocale]="true"
                           [mobileFriendlyZoom]="true"
                           [textLayer]="false"
  ></ngx-extended-pdf-viewer>
</div>
